import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Ventas.types';
import { IVentas } from './Ventas.lib';
import moment from 'moment';
import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';

export class Ventas extends IVentas {

    public static async create( mes: number, ano: number, empresa: string ): Promise<Ventas> {
        let o = new Ventas();
        o.Mes = mes;
        o.Ano = ano;
        o.Empresa = Empresa.toTipo( empresa );

        if ( await o.find() ) {
            return o;
        }
        return null;
    }

    public static async actual( empresa: string ): Promise<Ventas>
    {
        let o = new Ventas();
        if ( moment().getDay() < 7 )
        {
            o.Mes = moment().add( -1, 'month' ).getMonth();
            o.Ano = moment().add( -1, 'month' ).getYear();
        }
        else
        {
            o.Mes = moment().getMonth();
            o.Ano = moment().getYear();
        }

        o.Empresa = Empresa.toTipo( empresa );

        if ( await o.find() ) {
            return o;
        }
        return null;
    }
    protected Route: string = '/internal/bd4ec8e96b0d877a31d248/ventas';
    protected async find(): Promise<boolean> {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}`;
        request.params.empresa = this.Empresa.Id;
        request.params.mes = this.Mes;
        request.params.ano = this.Ano;
        if ( await request.get() ) {
            this.Json = request.data['resultados'][0]||{};
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Ventas>; Error?: boolean; }> {

        let a: Array<Ventas> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/internal/bd4ec8e96b0d877a31d248/ventas` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.resultados ) {
                for ( let i of request.data.resultados ) {
                    let p = new Ventas( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }
}